import React, { useEffect, useState } from "react";
import Question from "../components/Question";
import Modal from "../components/Modal";
import Start from "../components/Start";
import End from "../components/End";

let interval;

function Home({ token }) {
  const [step, setStep] = useState(1);
  const [activeQuestion, setActiveQuestion] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [time, setTime] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [quizData, setQuizData] = useState();
  const [examId, setExamId] = useState();
  const [correct, setCorrect] = useState();
  useEffect(() => {
    if (step == 3) {
      console.log("Time truly stopped");
      
      clearInterval(interval);
    }
  }, [step]);

  async function quizStartHandler() {
    console.log(quizData);
    if (quizData) {
      console.log(quizData.questions);
      setStep(2);
    }

    // interval = setInterval(() => {
    //   setTime((prevTime) => prevTime + 1);
    // }, 1000);
  }

  function resetClickHandler() {
    setActiveQuestion(0);
    setStep(1);
    setAnswers([]);
    setTime(0);
    // interval = setInterval(() => {
    //   setTime((prevTime) => prevTime + 1);
    // }, 1000);
  }

  return (
    <div className="App">
      {step === 1 && (
        <Start
          onQuizStart={quizStartHandler}
          token={token}
          setQuizData={setQuizData}
          setExamId={setExamId}
          examId={examId}
        />
      )}
      {step === 2 && (
        <Question
          onQuizStart={quizStartHandler}
          data={quizData.questions[activeQuestion]}
          onAnswerUpdate={setAnswers}
          numberOfQuestions={quizData.questions.length}
          activeQuestion={activeQuestion}
          setActiveQuestion={setActiveQuestion}
          onSetStep={setStep}
        />
      )}
      {step === 3 && (
        <End
          results={answers}
          data={quizData.questions}
          onReset={resetClickHandler}
          onAnswersCheck={() => {
            setShowModal(true);
          }}
          time={time}
          token={token}
          examId={examId}
          setCorrect={setCorrect}
        />
      )}
      {showModal && (
        <Modal
          onClose={() => {
            setShowModal(false);
          }}
          results={answers}
          data={quizData.questions}
          correct={correct}
        />
      )}
    </div>
  );
}

export default Home;
